import { ref, onValue, query } from '@firebase/database'
import { initializeFirebase } from 'libs/firebase'
import { getToken } from 'helpers/cookies.helper'
import { FIREBASE_TABLE_REF } from 'config'
import { FileBlockStatusEnum } from 'enum/fileBlockStatus.enum'
import { ImportProcess } from 'interfaces/ImportProcess'

const db = initializeFirebase()

/**
 * @description This function is used to wait for the import to finish listening to the status of the import process in firebase
 * @param id - token of the import process
 * @return Promise<void>
 **/
export const importFinish = (id: string) => {
  const {
    enterprise: { token },
  } = getToken()
  if (!db) {
    console.warn(
      "Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp()."
    )
    return
  }
  const firebaseRef = query(ref(db, `${FIREBASE_TABLE_REF}/${token}/${id}`))

  if (typeof id !== 'string') throw new Error('id must be a string')

  return new Promise<void>((resolve, reject) => {
    const subscription = onValue(
      firebaseRef,
      (snapshot) => {
        const importProcess: ImportProcess = snapshot.val()

        if (!importProcess) return
        const { status } = importProcess

        if (
          status === FileBlockStatusEnum.unstarted ||
          status === FileBlockStatusEnum.processing
        )
          return

        const total = importProcess.records.total
        if (
          status === FileBlockStatusEnum.failed ||
          (status === FileBlockStatusEnum.completedWithErrors && !total)
        )
          reject()
        else resolve()

        subscription?.()
      },
      reject
    )
    return subscription
  })
}
